// demo/main.js
import { createRoot } from "react-dom/client";
import App from "./app.jsx"; // your existing workbench

createRoot(document.getElementById("root")).render(<App />);
